import StageResource from './StageResource';

export default {
    stage: StageResource,
};

export type OperationResources = {
    stage: StageResource,
};
